import { Component, inject, PLATFORM_ID, OnInit, Injector } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { BaseClass } from './shared/class/BaseClass'; 
import { ToasterService } from './service/toaster.service';
import { MessagingService } from './service/messaging.service'; 
import { isPlatformBrowser } from '@angular/common';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { assets } from './core/constants/assets.const';

@Component({
    selector: 'notchmark-root',
    imports: [RouterOutlet, FormsModule, ToastModule, ConfirmDialogModule, NgxUiLoaderModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent extends BaseClass implements OnInit {
  title = 'NotchMark Student Panel';
  public toastService = inject(ToasterService);
  private _messagingService = inject(MessagingService);
  private platformId = inject(PLATFORM_ID);

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(injector: Injector) {
    super(injector);
    this._translateService.addLangs(['en']);
    this._translateService.setDefaultLang('en');
    
    // Keep your existing router subscription for scroll behavior
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd) 
    ).subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._messagingService.requestPermission();
      this._messagingService.listenForFrontMessages();
      this._translateService.get('notificationAlert').subscribe(() => {
        if (Notification.permission === 'denied') {
          alert(this._translateService.instant('Please enable browser notifications to receive important updates.'));
        }
      });
    }
    
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.action === 'navigate') {
        window.location.href = event.data.url;
      } else if (event.data && event.data.action === 'playNotificationSound') {
        this.playNotificationSound();
      }
    });

    // Additional router event subscription for body scroll reset
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        document.body.scrollTop = 0;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
    });
  }

  private playNotificationSound(): void {
    const audio = new Audio(assets.notificationSound); // Adjust path as needed
    audio.play().catch((error) => {
      console.error('Error playing notification sound:', error);
    });
  }

  onToastClose(): void {
    this.toastService.clearToast();
  }

  // Optional: if you want entire toast box clickable
  onToastClick(): void {
    this.toastService.clearToast();
  }
}
